import react, {useState} from "react";

import "./searchbar.css";

const SearchBar = () => {
    const [searchInput, setSearchInput] = useState("");
  return (
    <div className="search-box">
      <input
        type="text"
        className="search-input"
        placeholder="Search for something..."
      />
      <button className="search-icon">
        <i className="fa fa-search"></i>
      </button>
    </div>
  );
};

export default SearchBar;
